import { QueryTuple, useLazyQuery } from '@apollo/client';
import { OperatorType } from '@bechtel/sr-types';
import { GET_SELECT_LIST_DATA } from '~/gql';

export function useSelectListQuery(value: string, fetchFromNetwork?: boolean): QueryTuple<any, Record<string, any>> {
  const response = useLazyQuery(GET_SELECT_LIST_DATA, {
    notifyOnNetworkStatusChange: true,
    variables: {
      name: 'PICK_LIST.NAME',
      searchInput: {
        filterInput: {
          and: [
            {
              field: 'NAME',
              operator: OperatorType.EQUAL,
              value,
            },
          ],
        },
      },
    },
    fetchPolicy: fetchFromNetwork ? 'network-only' : 'cache-and-network',
  });

  return response;
}
